/**
 * CUA Grant Store — per-session grant state
 * Reference: TASK-UI-CU-005-1, SOL-UI-CU-005
 */

import { create } from 'zustand';
import { recordCUAConsent } from '../api/cuaSessionApi';
import type { PAType } from '../model/types';

export interface CUAGrantState {
  isGranted: boolean;
  sessionId: string | null;
  grant: (sessionId: string, pa?: PAType | string) => Promise<void>;
  revoke: () => void;
}

export const useCUAGrantStore = create<CUAGrantState>((set) => ({
  isGranted: false,
  sessionId: null,
  grant: async (sessionId: string, pa: PAType | string = 'pa2') => {
    try {
      await recordCUAConsent({
        session_id: sessionId,
        consent_version: 'v1',
        pa: (pa as PAType) ?? 'pa2',
      });
    } catch {
      // Continue even if network recording fails in offline mode
    }
    set({ isGranted: true, sessionId });
  },
  revoke: () => set({ isGranted: false, sessionId: null }),
}));

// Export alias for direct store access
export const cuaGrantStore = useCUAGrantStore;
